import React from 'react';
import { Clock, UserCheck, BadgeDollarSign, Award, Star, Phone } from 'lucide-react';
import { whyChooseUs, businessInfo } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  Clock,
  UserCheck,
  BadgeDollarSign,
  Award,
  Star
};

const WhyChooseSection = () => {
  return (
    <section id="why-us" className="py-20 md:py-28 bg-slate-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block text-amber-400 font-semibold text-sm uppercase tracking-wider mb-3">
              Why DC Lock and Key
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
              Trusted by South Perth Locals
            </h2>
            <p className="text-lg text-slate-300 mb-8">
              We've built our reputation on honest work, fair prices, and treating every customer like a neighbour. Here's why Perth locals choose DC Lock and Key.
            </p>

            {/* Mobile Image */}
            <div className="lg:hidden mb-8">
              <div className="relative rounded-2xl overflow-hidden border border-slate-700">
                <img
                  src={businessInfo.image}
                  alt="DC Lock and Key Professional Service"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Features List */}
            <div className="space-y-4">
              {whyChooseUs.map((item) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <div
                    key={item.id}
                    className="flex items-start gap-4 p-4 bg-slate-800/50 rounded-xl border border-slate-700 hover:border-amber-500/50 transition-colors"
                  >
                    <div className="w-12 h-12 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-6 h-6 text-amber-400" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white mb-1">{item.title}</h3>
                      <p className="text-slate-400">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-8">
              <a href={businessInfo.phoneLink}>
                <Button size="lg" className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold gap-2 px-8">
                  <Phone className="w-5 h-5" />
                  Get in Touch
                </Button>
              </a>
            </div>
          </div>

          {/* Right Image - Desktop */}
          <div className="hidden lg:block relative">
            <div className="absolute -inset-4 bg-amber-500/10 rounded-3xl blur-2xl"></div>
            <div className="relative rounded-2xl overflow-hidden border border-slate-700 shadow-2xl">
              <img
                src={businessInfo.image}
                alt="DC Lock and Key Professional Service"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-slate-800 rounded-xl p-6 border border-slate-700 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                  ))}
                </div>
              </div>
              <p className="text-white font-bold text-2xl mt-2">{businessInfo.rating}/5</p>
              <p className="text-slate-400 text-sm">{businessInfo.reviewCount} Google Reviews</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
